// extracted by mini-css-extract-plugin
export default {"root":"CardInput_root__dcQtJ","logo":"CardInput_logo__JIT1O"};